<template>
	<div class='multiple-list-block'>
		<table class='table-address-list table-common'>
			<thead>
				<tr>
					<th>Федеральный округ</th>
					<th>Субъект РФ</th>
					<th>Лесничество</th>
					<th>Участковое лесничество</th>
					<th>Урочище / дача</th>
					<th>Квартал</th>
					<th>Выдел</th>
					<th>Лп выдел</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for='(address, address_index) in multipleList' :class='{ "not-uniq": isNotUniq(address) }'>
					<td>{{ address.fo }}</td>
					<td>{{ address.region }}</td>
					<td>{{ address.forestry }}</td>
					<td>{{ address.localforestry }}</td>
					<td>{{ address.subforestry }}</td>
					<td>{{ address.area }}</td>
					<td>{{ address.section }}</td>
					<td>{{ address.section_lp }}</td>
					<td>
						<button @click='remove(address_index)'><i class='fa fa-trash'></i></button>
					</td>
					<!-- <td>{{ address.tax_id }}</td> -->
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'MultipleListBlock',
		props: {
			notUniqAddress: Object
		},
		computed: {
			...mapState('createLpo', {
				multipleList: state => state.multipleList,
			})
		},
		methods: {
			isNotUniq(address) {
				if (!this.notUniqAddress) {
					return false;
				}

				if (address.tax_id === this.notUniqAddress.tax_id &&
						address.section_lp === this.notUniqAddress.section_lp) {
					return true;
				}
			},

			remove(address_index) {
				this.removeAddressFromMultipleList(address_index);
			},

			...mapActions('createLpo', [
				'removeAddressFromMultipleList'
			])
		}
	};
</script>

<style scoped src='@/style/table.css'></style>

<style scoped>
	.table-address-list td {
		transition: background-color 0.2s ease;
	}
	.table-address-list tr.not-uniq td {
		background-color: orange;
	}
</style>